import { Box, IconButton, Typography, useTheme } from '@material-ui/core';
import { FC, MouseEventHandler, ReactNode } from 'react';

import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

interface Props {
  children?: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
  onClear: () => void;
  isOpened: boolean;
  maxWidth?: string;
  selected?: boolean;
  hideClear?: boolean;
  placeholder?: string;
  field?: string;
}

export const FilterInput: FC<Props> = ({
  onClick,
  onClear,
  isOpened,
  maxWidth = 'none',
  selected,
  children,
  hideClear,
  placeholder,
  field,
}) => {
  const theme = useTheme();

  return (
    <Box
      style={{
        maxWidth,
        height: '36px',
        borderRadius: '4px',
        padding: '6px 8px 6px 12px',
        border: `1px solid ${theme.palette.grey[300]}`,
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        background: Boolean(selected)
          ? theme.palette.grey[100]
          : theme.palette.background.default,
      }}
      onClick={onClick}
    >
      {placeholder && !selected ? (
        <Typography
          style={{
            color: theme.palette.secondary.light,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {placeholder}
        </Typography>
      ) : (
        children
      )}

      <Box
        style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}
      >
        {selected && (
          <>
            {!hideClear && (
              <IconButton
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  onClear();
                }}
                size="small"
                aria-label="clear filter"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )}

            <Box
              style={{
                width: '1px',
                height: '20px',
                background: theme.palette.grey[300],
                margin: '0px 5px',
              }}
            />
          </>
        )}

        <IconButton
          style={{
            transition: 'all 0.3s',
            transform: isOpened ? 'rotate(180deg)' : 'rotate(-90deg)',
          }}
          onClick={onClick}
          size="small"
          aria-label={
            isOpened ? `close ${field} filter` : `open ${field} filter`
          }
        >
          <ExpandMoreIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
